import Link from 'next/link';
import React from 'react';

export interface BlurbShape {
  key: string;
  title?: string;
  text: React.ReactElement | string;
  buttonText?: string;
  buttonLink?: string;
  imageUrl?: string;
  imageAlt?: string;
  icon?: string;
}

interface IProps {
  content: BlurbShape;
}

export const Blurb: React.FC<IProps> = ({ content }) => (
  <div className='flex w-full flex-col overflow-hidden rounded-lg bg-white shadow-lg md:grow md:basis-0'>
    {content?.icon && (
      <div className='bg-red-50 relative mx-4 mt-4 flex size-20 items-center justify-center overflow-hidden rounded-lg md:mx-6 md:mt-6 md:size-28'>
        <div className='absolute flex size-12 items-center justify-center overflow-hidden md:size-20'>
          <i className={content?.icon} style={{ fontSize: 'clamp(32px, 5vw, 64px)' }}></i>
        </div>
      </div>
    )}
    {content.imageUrl && (
      <div className='flex w-full items-center justify-start p-4'>
        <img
          src={content.imageUrl}
          alt={content.imageAlt || content.title || 'Blurb image'}
          className='size-[104px] object-cover'
        />
      </div>
    )}

    <div className='flex flex-1 flex-col gap-3 p-4 md:gap-2 md:py-6'>
      {content.title && (
        <div className='text-red-950 justify-start self-stretch text-base font-bold leading-normal sm:text-lg md:text-xl'>
          {content.title}
        </div>
      )}

      <div className='text-red-950 flex-1 justify-start text-sm font-normal leading-relaxed md:text-base'>
        {content.text}
      </div>

      {content.buttonLink && content.buttonText && (
        <div className='mt-auto pt-4'>
          <Link href={content.buttonLink} className='inline-block w-full md:w-auto'>
            <div className='inline-flex w-full items-center justify-center gap-2 rounded-lg bg-raspberry px-4 py-3 font-bold text-white transition-colors duration-200 hover:bg-raspberry-hover md:w-auto md:px-6 md:py-3'>
              {content.buttonText}
              <i className='fal fa-arrow-right'></i>
            </div>
          </Link>
        </div>
      )}
    </div>
  </div>
);
